import React from 'react';
import { maxListedDaysAgoOptions } from '@th/shared/src/types/SearchFilters';
import getMaxDaysAgoWithCustomOptions from '@th/shared/src/helpers/searchFilters/getMaxDaysAgoWithCustomOptions';
import { useSearch } from '../../contexts/SearchContext';
import Menu from '../Menu/Menu';
import MenuButton from '../Menu/MenuButton';
import MenuItems from '../Menu/MenuItems';
import Switch from '../Switch';
import MenuItem from '../Menu/MenuItem';
import { defaultFilters } from '@th/shared/src/constants/searchFilters';
import isDefined from '@th/shared/src/utils/isDefined';
import { twMerge } from 'tailwind-merge';
import useWindowDimensions from '../../hooks/useWindowDimensions';

export default function ForSaleQuickFilter({}) {
  const {
    updateFilters,
    toggleShowActive,
    searchFilters,
    isSaleTransactionType,
  } = useSearch();
  const { isMobile } = useWindowDimensions();

  const maxListedDaysAgo = isDefined(searchFilters.maxListedDaysAgo)
    ? searchFilters.maxListedDaysAgo
    : defaultFilters.maxListedDaysAgo;

  const isActive = searchFilters.showActive;

  const forSaleText = isMobile ? 'Sale' : 'For Sale';

  return (
    <Menu>
      <MenuButton
        text={isSaleTransactionType ? forSaleText : 'For Rent'}
        chevron
        className={twMerge(
          'bg-forSale hover:bg-forSalePreviouslyViewed text-white border border-transparent',
          !isActive &&
            'bg-white hover:bg-lightGray border border-mediumLightGray text-text ',
        )}
      />
      <MenuItems>
        <Switch
          label="Show"
          isChecked={searchFilters.showActive}
          onChange={toggleShowActive}
          className="py-2 px-2"
        />

        {getMaxDaysAgoWithCustomOptions(
          maxListedDaysAgo,
          maxListedDaysAgoOptions,
        ).map(({ label, value }, i) => (
          <MenuItem
            key={i}
            text={label}
            isSelected={maxListedDaysAgo === value}
            onClick={() => {
              updateFilters({ maxListedDaysAgo: value });
            }}
          />
        ))}
      </MenuItems>
    </Menu>
  );
}
